import script from "./namespaces.vue?vue&type=script&setup=true&lang=ts"
export * from "./namespaces.vue?vue&type=script&setup=true&lang=ts"

import "./namespaces.vue?vue&type=style&index=0&id=717e06d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717e06d2"]])

export default __exports__